/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import clsx from 'clsx';
import MainHeader from "../../../../Shared/components/Header";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import { TextField } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Link, NavLink, useParams } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { SupplierTable } from "../../../../Purchase/Management/components/AllSuppliers/SupplierTable";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import usePrevious from "../../../../Shared/components/Previous";
import crudActions from "../../../../CRUD/redux/actions";
import groupActions from "../../../Setup/redux/actions";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { useEventListener } from "../../../../../helpers/useEventListener"
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const Suppliers = (props) => {
    const { supplierDetails, loader } = useSelector(state => state.purchaseManagementReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { supplierGroupDetails } = useSelector(state => state.purchaseSetupReducer);

    const dispatch = useDispatch();
    const { groupId } = useParams();
    const { history } = props;
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);

    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const limit = 25;
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [filterGroupId, setFilterGroupId] = useState(groupId || '');


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(filterGroupId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(filterGroupId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {

            if (checkViewPermission('All Suppliers', history, 'Purchase')) {
                loadTasks();
            }
        }

    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 78) {
            e.preventDefault();
            history.push(`/purchase/purchase-management/all-suppliers/create`);
        }
    }
    useEventListener("keydown", handleKeyDown);


    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (filterGroupId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (search !== '') {
            or['or'].push({ name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
            or['or'].push({ classification: { like: '%' + search.trim() + '%' } });
        }
        if (filterGroupId) {
            filter['and'].push({ groupId: parseInt(filterGroupId) });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'supplierProfile',
            skip: skip,
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };
        if (search !== '') {
            or['or'].push({ name: { like: '%' + search.trim() + '%' } });
            or['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            or['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
            or['or'].push({ classification: { like: '%' + search.trim() + '%' } });
        }
        if (filterGroupId) {
            filter['and'].push({ groupId: parseInt(filterGroupId) });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        dispatch({
            type: actions.SUPPLIER_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'supplierProfile',
            filter: {
                where: !filter.and || filter.and.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: groupActions.SUPPLIERGROUP_DETAILS_START,
            url: 'supplier-group',
            filter: {
                order: 'id desc '
            }
        });
        dispatchFilter(filterGroupId, sortBy, sortOrder);
    });

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(filterGroupId, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(filterGroupId, sortBy, sortOrder, s);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                closeLink={'/purchase'}
                img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'All Suppliers', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'All Suppliers'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={14} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('All Suppliers', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Name, ID, Ph.No., & Classification'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'supplierProfile', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={10} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.vertiCalScrollOverFlowParent,
                                    classes.customerLabelNone)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center" >
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Suppliers', 'Action', 'Filter Group') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Group"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }, { 'key': 'description', 'name': 'Description' }]}
                                                    details={supplierGroupDetails}
                                                    parentValue={customObject(supplierGroupDetails, parseInt(filterGroupId))}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    id={idNamingConversion('All Group', 'supplierProfile', 'DropDown')}
                                                    customClasses={clsx(classes.customWidth160P)}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            setFilterGroupId('');
                                                            dispatchFilter('', sortBy, sortOrder);
                                                        }
                                                    }}
                                                    onChange={(data) => {
                                                        setFilterGroupId(data.id) // help to set the value
                                                        dispatchFilter(data.id, sortBy, sortOrder);
                                                    }}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Suppliers', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'supplierProfile', 'Link')}
                                                    onClick={() => { loadImportExportData('Suppliers'); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Suppliers', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'supplierProfile', 'Link')}
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('All Suppliers', 'create', 'Purchase') &&
                                                <Link id={idNamingConversion('Add Supplier', 'supplierProfile', 'Link')} to={`/purchase/purchase-management/all-suppliers/create`} className={clsx(classes.customLink)}>
                                                    <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Supplier</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('All Suppliers', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <SupplierTable
                                filterGroupId={filterGroupId}
                                search={search}
                                loadTasks={() => dispatchFilter(filterGroupId, sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortBy={sortBy} sortOrder={sortOrder}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Suppliers'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={supplierDetails}
                loadTasks={() => { dispatchFilter(filterGroupId, sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}
export default Suppliers